/** Joins class names, skipping what is not one, so a condition can sit inline in a class list. */
export function cx(...parts: readonly (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
